// extracted by mini-css-extract-plugin
module.exports = {"sort_icon":"SortHeader_sort_icon__2E53t"};